import type { PackageFormV2WritingCompanyScope } from '@lio/api-types';

const WRITING_COMPANY_LABELS: Record<string, string> = {
  'LIO Specialty Insurance Company': 'LSIC',
  'LIO Insurance Company': 'LIC',
};

export const formatWritingCompanyLabel = (name: string | null | undefined, emptyLabel: string | null = 'All') => {
  if (!name) return emptyLabel as string;
  return WRITING_COMPANY_LABELS[name] ?? name;
};

export const normalizeWritingCompanyScope = (writingCompanyId: string | null | undefined) => writingCompanyId || null;

export const PACKAGE_SCOPE_LABELS: Record<PackageFormV2WritingCompanyScope, string> = {
  ALL: 'All',
  LIC: 'LIC',
  LSIC: 'LSIC',
};

/** Uniquely identifies a package assignment by (packageId, scope) — missing scope defaults to ALL for legacy data. */
export const getPackageAssignmentKey = (item: {
  packageId: string;
  writingCompanyScope?: PackageFormV2WritingCompanyScope;
}) => `${item.packageId}:${item.writingCompanyScope ?? 'ALL'}`;
